/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_SubmitInputs */

const en_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposit`)
};

const de_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzahlen`)
};

const pt_br2_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depositar`)
};

const tr_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para yatır`)
};

const zh_cn2_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入`)
};

const zh_hk2_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入`)
};

const ko_kr2_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입금`)
};

const ru_ru2_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пополнить`)
};

const es_419_onboarding_v1_fund_submit = /** @type {(inputs: Onboarding_V1_Fund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depositar`)
};

/**
* | output |
* | --- |
* | "Deposit" |
*
* @param {Onboarding_V1_Fund_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_submit = /** @type {((inputs?: Onboarding_V1_Fund_SubmitInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_SubmitInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_submit(inputs)
	if (locale === "de") return de_onboarding_v1_fund_submit(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_submit(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_submit(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_submit(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_submit(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_submit(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_submit(inputs)
	return es_419_onboarding_v1_fund_submit(inputs)
});